import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import UtilityBar from "../components/site/UtilityBar";
import QuoteDialog from "../components/site/QuoteDialog";
import CatalogDialog from "../components/site/CatalogDialog";
import AccessibilityPanel from "../components/site/AccessibilityPanel";
import MobileStickyBar from "../components/site/MobileStickyBar";
import SeoHead from "../components/site/SeoHead";
import "../components/site/journal.css";

function initialDocument(path) {
  try {
    const doc = JSON.parse(document.getElementById("seo-bootstrap")?.textContent || "null");
    return doc?.path === path ? doc : null;
  } catch (_) { return null; }
}

export default function BlogPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [doc, setDoc] = useState(() => initialDocument(location.pathname));
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [catalogOpen, setCatalogOpen] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const initial = initialDocument(location.pathname);
    setDoc(initial); setError(false);
    if (initial && !retry) return () => controller.abort();
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/seo/page?path=${encodeURIComponent(location.pathname + location.search)}`, {signal: controller.signal})
      .then(response => { if (!response.ok) throw new Error("Unavailable"); return response.json(); })
      .then(data => { if (data.location) navigate(data.location, {replace: true}); else setDoc(data); })
      .catch(err => { if (err.name !== "AbortError") setError(true); });
    return () => controller.abort();
  }, [location.pathname, location.search, navigate, retry]);

  useEffect(() => {
    if (!doc) return;
    let schema = document.getElementById("page-jsonld");
    if (!schema) { schema = document.createElement("script"); schema.id = "page-jsonld"; schema.type = "application/ld+json"; document.head.appendChild(schema); }
    schema.textContent = JSON.stringify(doc.schemas);
    return () => schema.remove();
  }, [doc]);

  return <div data-testid="blog-page" className="bg-cream pb-16 md:pb-0 font-nunito">
    {doc && <SeoHead title={doc.title} description={doc.description} path={doc.path} noindex={doc.status === 404} image={doc.image} type={doc.path.startsWith('/blog/') ? 'article' : 'website'} />}
    <UtilityBar />
    <Header solid onRequestQuote={() => setQuoteOpen(true)} onDownloadCatalog={() => setCatalogOpen(true)} />
    <main className="journal-main container-vlx">
      {error ? <section data-testid="journal-error" role="alert"><h1>The journal is temporarily unavailable.</h1><button className="btn-pill btn-primary mt-6" data-testid="journal-retry" onClick={() => setRetry(n => n + 1)}>Try again</button></section>
        : doc ? <div dangerouslySetInnerHTML={{__html: doc.body}} />
        : <p role="status" data-testid="journal-loading">Loading the journal…</p>}
    </main>
    <Footer onDownloadCatalog={() => setCatalogOpen(true)} />
    <QuoteDialog open={quoteOpen} onClose={() => setQuoteOpen(false)} />
    <CatalogDialog open={catalogOpen} onClose={() => setCatalogOpen(false)} />
    <AccessibilityPanel />
    <MobileStickyBar onRequestQuote={() => setQuoteOpen(true)} />
  </div>;
}